if (!window.Promise) {
    window.Promise = require('promise-polyfill');
}

Array.from = require('array-from');

require('intersection-observer');
require('string.prototype.startswith');
require('string.prototype.endswith');
require('es6-object-assign').polyfill();
require('object.values').shim();
require('custom-event-polyfill');
require('element-closest');
require('details-element-polyfill');



// WEBPACK FOOTER //
// ./src/js/lib/polyfills.js